export default "__VITE_ASSET__CpUCyygV__"